import api from '../utils/api';
import GireApi from '../utils/gire_api';
import setAlert from './setAlert';
import * as actionTypes from './types';
import setAuthToken from "../utils/setAuthToken";
import SetConnectAuthToken from "../utils/setConnectAuthToken";
import axios from 'axios';
import setAuthTokenAdmin from "../utils/setAuthTokenAdmin";

const baseURL = 'https://primeprivatenetwork.com/api';
//const baseURL = 'http://localhost:3000/api';
// Load User
export const loadUser = () => async dispatch => {
    try {
        const res = await api.get('/auth');

        dispatch({
            type: actionTypes.USER_LOADED,
            payload: res.data.data
        });
    } catch (err) {
        dispatch({
            type: actionTypes.AUTH_ERROR
        });
    }
};

export const loadUserAdmin = () => async dispatch => {
    try {
        const res = await api.get('/auth');

        dispatch({
            type: actionTypes.USER_LOADED_ADMIN,
            payload: res.data.data
        });
    } catch (err) {
        dispatch({
            type: actionTypes.AUTH_ERROR
        });
    }
};

// Register User
export const register = (formData, history) => async dispatch => {
    try {
        const res = await api.post('/users', formData);

        dispatch({
            type: actionTypes.REGISTER_SUCCESS,
            payload: res.data
        });
        console.log(res.data.data.token);
        //!formData.type === "ADD_USER" && setAuthToken(res.data.data.token);
        (formData.type === "ADD_USER" && history) && history.push('/users');
        setAuthToken(res.data.data.token);
        setAlert(res.data.message, 'success');
        dispatch(loadUser());
    } catch (err) {
        setAlert(err.message, 'error');
        dispatch({
            type: actionTypes.REGISTER_FAIL,
            payload: err
        });
    }
};

// Login User
export const login = (email, password,) => async dispatch => {
    const body = {email, password};

    try {

        const res = await api.post('/auth', body);
        dispatch({
            type: actionTypes.LOGIN_SUCCESS,
            payload: res.data.data
        });
        setAuthToken(res.data.token);
        dispatch(loadUser());
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error')
        }
        dispatch({
            type: actionTypes.LOGIN_FAIL
        });
    }
};

export const loginAdmin = (email, password,) => async dispatch => {
    const body = {email, password};

    try {

        const res = await api.post('/auth', body);
        dispatch({
            type: actionTypes.LOGIN_SUCCESS_ADMIN,
            payload: res.data.data
        });
        setAuthTokenAdmin(res.data.token);
        dispatch(loadUserAdmin());
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error')
        }
        dispatch({
            type: actionTypes.LOGIN_FAIL_ADMIN
        });
    }
};

// forgot password

export const forgotPassword = (email) => async dispatch => {
    const body = {email};
    try {
        dispatch({
            type: actionTypes.FORGOT_LOADER,
            payload: true
        });
        const res = await api.post('/auth/forgot-password', body);
        dispatch({
            type: actionTypes.FORGOT_SUCCESS,
            payload: res.data
        });
        dispatch({
            type: actionTypes.FORGOT_LOADER,
            payload: false
        });
        setAlert(res.data.data[0].msg, 'success')
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach(error => setAlert(error.msg), 'danger')
        }
        dispatch({
            type: actionTypes.FORGOT_FAIL
        })
    }

};

export const changePassword = (request) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.CHANGE_LOADER,
            payload: true
        });
        const res = await api.post('/auth/change-password', JSON.stringify(request));
        dispatch({
            type: actionTypes.CHANGE_SUCCESS,
            payload: res.data
        });
        dispatch({
            type: actionTypes.CHANGE_LOADER,
            payload: false
        });
        setAlert(res.data.message, 'success')
    } catch (err) {
        setAlert(err.message, 'error')
    }

};

//reset password
export const resetPassword = (request, history) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.RESET_LOADER,
            payload: true
        });
        const config = {
            headers: {
                "Content-Type": "application/json"
            }
        };
        // const res = await api.post('/auth/change-password', JSON.stringify(request));
        const res = await axios.post(baseURL + '/auth/reset-password', JSON.stringify(request), config);
        if (parseInt(res.status) === 200) {
            dispatch({
                type: actionTypes.RESET_SUCCESS,
                payload: res.data
            });
            dispatch({
                type: actionTypes.RESET_LOADER,
                payload: false
            });
            setAlert(res.data.message, 'success')
            history && history.push('/login');
        }
    } catch (err) {
        setAlert(err.message, 'error')
    }

};

// GET PROFILE DATA
export const actionGetProfileData = (id) => async dispatch => {

    try {
        dispatch({
            type: actionTypes.GET_PROFILE_DATA_LOADER,
            payload: true
        });
        const res = await api.get(`/users/${id}`);
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.GET_PROFILE_DATA_LOADER,
                payload: res.data
            });
            dispatch({
                type: actionTypes.GET_PROFILE_DATA,
                payload: false
            });

        } else {
            dispatch({
                type: actionTypes.GET_PROFILE_DATA_LOADER,
                payload: false
            });

        }

    } catch (err) {
        // const errors = err.response.data.errors;
        // if(errors){
        //     errors.forEach(error => dispatch(setAlert(error.msg),'danger'))
        // }
        dispatch({
            type: actionTypes.GET_PROFILE_DATA_LOADER,
            payload: false
        });

    }

};
// ADD UPDATE PROFILE
export const actionAddUpdateProfile = (request, id) => async dispatch => {

    try {
        dispatch({
            type: actionTypes.ADD_UPDATE_PROFILE_LOADER,
            payload: true
        });
        const res = await api.put(`/users/${id}`, request);
        console.log(res.data.data, "rerrr");
        if (parseInt(res.data.status) === 200) {
            console.log(res.data.data, "responce////");
            dispatch({
                type: actionTypes.ADD_UPDATE_PROFILE_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.ADD_UPDATE_PROFILE_DATA,
                payload: res.data.data
            });

            dispatch(setAlert(res.data.message), 'success')
        } else {
            dispatch({
                type: actionTypes.ADD_UPDATE_PROFILE_LOADER,
                payload: false
            });
            dispatch(setAlert(res.data.message), 'error')
        }

    } catch (err) {
        // const errors = err.response.data.errors;
        // if(errors){
        //     errors.forEach(error => dispatch(setAlert(error.msg),'danger'))
        // }
        dispatch({
            type: actionTypes.ADD_UPDATE_PROFILE_LOADER,
            payload: false
        });

    }

};


// ADD UPDATE USER RPROFILE_PIC
export const actionAddUpdateUserProfilePic = (formData, setProfilePic) => async dispatch => {

    try {
        dispatch({
            type: actionTypes.ADD_UPDATE_USER_PROFILE_PIC_LOADER,
            payload: true
        });
        const res = await api.post(`/upload`, formData, {headers: {'Content-Type': 'multipart/form-data'}});

        if (parseInt(res.data.status) === 200) {

            dispatch({
                type: actionTypes.ADD_UPDATE_USER_PROFILE_PIC_LOADER,
                payload: false
            });
            setProfilePic && setProfilePic(res.data.image, res.data.file_name);
            dispatch({
                type: actionTypes.ADD_UPDATE_USER_PROFILE_PIC,
                payload: res.data
            });
            dispatch({
                type: actionTypes.ADD_UPDATE_COMPANY_LOG,
                payload: res.data
            });

            dispatch(setAlert(res.data.message), 'success')
        } else {
            dispatch({
                type: actionTypes.ADD_UPDATE_USER_PROFILE_PIC_LOADER,
                payload: false
            });
            dispatch(setAlert(res.data.message), 'error')
        }

    } catch (err) {
        // const errors = err.response.data.errors;
        // if(errors){
        //     errors.forEach(error => dispatch(setAlert(error.msg),'danger'))
        // }
        dispatch({
            type: actionTypes.ADD_UPDATE_USER_PROFILE_PIC_LOADER,
            payload: false
        });

    }

};


// Logout
export const logout = () => ({type: actionTypes.LOGOUT});
export const logoutAdmin = () => ({type: actionTypes.LOGOUT_ADMIN});


//  Connect to Global India RealEstate
export const actionConnectToGRIRE = (request, id) => async dispatch => {
    dispatch({
        type: actionTypes.CONNECT_TO_GIRE_LOADER,
        payload: true
    });
    try {
        const result = await GireApi.post('/login', JSON.stringify(request));

        if (parseInt(result.data.status) === 200) {

            const {accessToken, user_id} = result.data.data;
            const request = {
                gire_token: accessToken,
                gire_user_id: user_id
            };
            try {
                const res = await api.put(`/users/${id}`, request);
                if (parseInt(res.data.status) === 200) {
                    SetConnectAuthToken("GIRE", accessToken);
                    setAlert('Successfully Connected', 'success')

                    dispatch({
                        type: actionTypes.CONNECT_TO_GIRE_SUCCESS,
                        payload: result.data.data
                    });
                    dispatch({
                        type: actionTypes.CONNECT_TO_GIRE_LOADER,
                        payload: false
                    });
                }
                else {
                    setAlert(res.data.message, 'error')
                }
            }
            catch (e) {
                console.log(e)
            }


        }
        else {
            dispatch({
                type: actionTypes.CONNECT_TO_GIRE_LOADER,
                payload: false
            });
            setAlert(result.data.message, 'error')
        }
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error')

        }
        dispatch({
            type: actionTypes.CONNECT_TO_GIRE_LOADER,
            payload: false
        });
    }
};

//Make Notification Read
export const actionIsNotificationRead = (userId) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.ADD_READ_NOTIFICATION_LOADER,
            payload: true
        });
        const res = await api.put(`/notification/read/${userId}`);
        if (parseInt(res.status) === 200) {
            dispatch({
                type: actionTypes.ADD_READ_NOTIFICATION,
                payload: userId
            });
            dispatch({
                type: actionTypes.ADD_READ_NOTIFICATION_LOADER,
                payload: false
            });
        }

        //setAlert(res.data.message, 'success')
    } catch (err) {
        setAlert(err.message, 'error')
    }

};

